import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'kwdCurrency',
  standalone: true
})
export class KwdCurrencyPipe implements PipeTransform {
  transform(value: number | null | undefined, decimalPlaces: number = 3): string {
    if (value == null || value === undefined) {
      return '0.000 KWD';
    }
    
    return `${value.toFixed(decimalPlaces)} KWD`;
  }
}
